'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { AppContext, DataLinkContainer, ScrollableDataListRV, translation } from 'plugin/liferay-widgets-react-web';

import { getAssetLinkStore } from '../stores/StoreFactory';
import BusinessObjectLink from './BusinessObjectLink';
import Icon from './Icon';

import { ListGroupItem, Button, OverlayTrigger, Tooltip } from 'external/react-bootstrap';

// eslint-disable-next-line react/prop-types
const BusinessObjectListItem = ({ item, onDeleteAttachedAsset }) => {
  return (
    <ListGroupItem>
      {translation.trans(item.className) + ': '}
      <BusinessObjectLink
        className={item.className}
        classPK={item.classPK}
      />
      {
        onDeleteAttachedAsset && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Löschen</Tooltip>}
          >
            <Button
              variant="outline-primary"
              className="pull-right delete-button"
              onClick={onDeleteAttachedAsset.bind(null, item)}
              title="Löschen"
            >
              <Icon name="x"/>
            </Button>
          </OverlayTrigger>
        )
      }

    </ListGroupItem>
  );
};

const LinkedAttachedDocList = DataLinkContainer.link(ScrollableDataListRV, 'list', getAssetLinkStore(AppContext));

class AttachedObjectList extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { list, moreAttachedEntities, onDeleteAttachedAsset, size = 350, ...otherProps } = this.props;
    let List = ScrollableDataListRV;

    if (typeof list === 'string') {
      List = LinkedAttachedDocList;
    }

    return (
      <List
        list={list}
        size={size}
        onDeleteAttachedAsset={onDeleteAttachedAsset}
        ListItem={BusinessObjectListItem}
        onClickMore={moreAttachedEntities}
        {...otherProps}
      />
    );
  }
}

AttachedObjectList.propTypes = {
  list: PropTypes.oneOfType([ PropTypes.object, PropTypes.string, PropTypes.array ]).isRequired,
  onDeleteAttachedAsset: PropTypes.func,
  moreAttachedEntities: PropTypes.func,
  size: PropTypes.number
};

export default AttachedObjectList;



// WEBPACK FOOTER //
// ./js/components/AttachedObjectList.jsx